import React, { useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import * as queryString from 'query-string'
import { Button, Col, Form, FormControl, Row } from 'react-bootstrap'
import DaumPostCode, { Address } from 'react-daum-postcode'
import { ActionResult, HttpMethod, PostModel } from '../../model'
import { SurveyJson, SurveyOption } from '../../model/survery/SurveyJson'
import { httpClient } from '../../service'
import AppUpdatePage from '../../shared/AppUpdatePage'
import moment from 'moment'

interface SurveyExtendModel extends SurveyJson {
    addr1?: string;
    addr2?: string;
    files?: File[];
}

const Ho = (props: RouteComponentProps<{ code: string }>) => {
    // const match = props.match;
    const surveyCode = 'suv2'// match.params.code;
    const qs = queryString.parse(props.location.search);
    const custNo = typeof qs.custNo === ('string') ? `${qs.custNo}` ?? null : null;
    const couponId = Number(qs.couponId) ?? 0;
    // console.log(`custNo = ${custNo} // memberId = ${memberId} // couponId = ${couponId}`);
    // const today = moment(new Date());
    // const tday = moment("2022-07-01");
    // const duration = moment.duration(today.diff(tday));
    // const days = duration.asDays();
    // const isHidden = days < 0;

    // console.log(days);
    // console.log(isHidden);

    const [model, setModel] = useState<SurveyExtendModel>({
        custNo: custNo!,
        name: '',
        mobile: '',
        couponId: couponId,
        code: surveyCode,
        isGiveAway: true,
    })
    const [surveyOptions, setSurveyOptions] = useState<SurveyOption[]>([]);
    const [validated, setValidated] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const option1list = ['서울', '경기', '강원', '충남', '충북', '전남', '전북', '경남', '경북', '제주'];
    const option2list = ['남성', '여성'];
    const option3list = ['매우 만족', '만족', '보통', '불만족', '매우 불만족'];
    const option4list = ['평화의 터(모슬포 워커 운동장)', '舊 육군제1훈련소 정문', '해병3•4기호국관', '강병대교회', '舊 대정면사무소', '신영물', '모슬포 천주교회(사랑의 집)', '대정중 6.25참전 소년병 추모공간(침묵의 뜰)', '대승사', '제29사단 발상탑(주먹탑)', '제주항일기념관',
    '제주의병항쟁기념탑', '월남 참전기념탑', '해병혼탑', '6.25참전 기념탑', '특전사 충혼비', '무오법정사 및 의열사', '제주 해녀항일운동기념탑', '호국영웅 고태문로 표지석', '호국영웅 강승우로 표지석', '호국영웅 김문성로 표지석', '호국영웅 한규택로 표지석'];



    const [openPost, setOpenPost] = useState(false);
    const handlePostOpen = (e: any) => {
        e.target.blur();
        setOpenPost(true);

    }
    const handlePostClose = () => setOpenPost(false);
    const [address, setAddress] = useState('');
    const handleComplete = (data: Address) => {
        const param: PostModel = { post: data.zonecode, address: data.address, buildingName: data.buildingName };
        const rvalue = JSON.stringify(param);
        console.log(rvalue);
        setOpenPost(false);
        const address = `${param.address} ${param.buildingName}`;
        console.log(address);
        setAddress(address);
        const sumAddr = `${address} ${(model.addr2 !== undefined ? model.addr2 : '')}`;
        setModel({ ...model, 'addr1': address, 'dev3': sumAddr });
    }
    const handleInputChange = (e: any) => {
        console.log(`name=${e.target.name}, value=${e.target.value}`);
        const data = { ...model, [e.target.name]: e.target.value };
        setModel(data);
        if (e.target.name === 'addr2') {
            const sumAddr = `${(model.addr1 !== undefined ? model.addr1 : '')} ${e.target.value}`;
            setModel({ ...model, 'dev3': sumAddr });
        }
    }

    const handleRadioChange = (e: any) => {
        let rval = false;
        const value = e.target.value;
        console.log(`name=${e.target.name}, value=${value}`);

        if (value && typeof value === 'string') {
            if (value.toLowerCase() === 'true') {
                rval = true;
            } else {
                rval = false;
            }
        }
        const data = { ...model, [e.target.name]: rval };
        setModel(data);
    }

    interface fileModel {
        id: number;
        fileFlag: string;
        value: string | Blob;
    }

    const handelChildDepthChagen = (depth: number, e: any) => {
        console.log(depth);
        console.log(`name=${e.target.name}, value=${e.target.value}`);
        const surveyOption = surveyOptions.filter(x => x.depth === depth)[0];
        const surveyList = surveyOptions.filter(x => x.depth !== depth);

        console.log(`1 surveyOption = ${surveyOption}`);
        let data = { depth: depth };
        if (surveyOption !== undefined) {
            console.log(`not undefined`);
            data = { ...surveyOption, [e.target.name]: e.target.value };
        } else {
            console.log(`undefined`);
            data = { depth: depth, [e.target.name]: e.target.value };
        }
        console.log(`1 surveyOption = ${JSON.stringify(surveyOption)} // item = ${JSON.stringify(data)}`);
        const suvOptionDatas = surveyList.length > 0 ? [...surveyList, data] : [data];
        setSurveyOptions(suvOptionDatas);
        setModel({ ...model, surveyOptions: suvOptionDatas });
    }
    const [files, setFiles] = useState<fileModel[]>([
        { id: 0, fileFlag: '', value: '' },
        {
            id: 1,
            fileFlag: '',
            value: '',
        }])
    const [fileNames, setFileNames] = useState([{ id: 0, value: '파일을 선택 해 주세요.' }, {
        id: 1,
        value: '파일을 선택 해 주세요.',
    }])
    const handleFile = (inx: number, fileTyep: string, e: any) => {
        const file = e.target.files[0];
        const name = { id: inx, value: file.name };
        const otherName = fileNames.filter(x => x.id !== inx);
        setFileNames([...otherName, name]);
        console.log(e.target.files);
        const otherFile = files.filter(x => x.id !== inx);
        const fileData = { id: inx, fileFlag: fileTyep, value: file };
        setFiles([...otherFile, fileData]);
    }

    const resetForm = () => {
        const resetData = {
            custNo: custNo!,
            name: '',
            mobile: '',
            couponId: couponId,
            code: surveyCode,
            isGiveAway: true,
        }
        const resetFiles = [{ id: 0, fileFlag: '', value: '' }, { id: 1, fileFlag: '', value: '' }];
        const resetFileNames = [{ id: 0, value: '파일을 선택 해 주세요.1' }, { id: 1, value: '파일을 선택 해 주세요.2' }];
        setModel(resetData);
        setFiles(resetFiles);
        setFileNames(resetFileNames);
        setSurveyOptions([]);
        setAddress('');
    }

    const submitForm = async (e: any) => {
        const isValid = e.currentTarget.checkValidity();
        if (!isValid) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return false;
        }
        e.preventDefault();

        const form = e.target;
        setSubmitting(true);
        // const sumAddress = `${model.addr1} ${model.addr2}`;
        // setModel({...model, "dev3": sumAddress});
        console.log(`form state=${JSON.stringify(model)}`);
        console.log(files);
        const formData = new FormData();

        formData.append('custNo', model.custNo);
        // formData.append('memberId', `${model.memberId}`)
        formData.append('code', model.code);
        formData.append('name', model.name);
        formData.append('mobile', model.mobile);
        formData.append('isGiveAway', `${model.isGiveAway}`);
        // formData.append('surveyOptions[]', JSON.stringify(model.surveyOptions));
        model.surveyOptions?.map(x => {
            console.log(x);
            if (x !== undefined) {
                console.log(x.depth);
                formData.append('surveyOptions[0].depth', `${x.depth}`);
                if (x.option1 && x.option1 !== undefined) {
                    formData.append('surveyOptions[0].option1', x.option1);
                }
                if (x.option2 && x.option2 !== undefined) {
                    formData.append('surveyOptions[0].option2', x.option2);
                }
                if (x.option3 && x.option3 !== undefined) {
                    formData.append('surveyOptions[0].option3', x.option3);
                }
                if (x.option4 && x.option4 !== undefined) {
                    formData.append('surveyOptions[0].option4', x.option4);
                }
            }
        })
        if (model.couponId && model.couponId !== undefined) {
            console.log(`couponId ${model.couponId}`);
            formData.append('couponId', `${model.couponId}`);
        }
        if (model.dev1 && model.dev1 !== undefined) {
            formData.append('dev1', model.dev1);
        }
        if (model.dev2 && model.dev2 !== undefined) {
            formData.append('dev2', model.dev2);
        }
        if (model.dev3 && model.dev3 !== undefined) {
            formData.append('dev3', model.dev3);
        }


        files.map((x, i) => {
            if (x.value && x.value!=='') {
                const file: any = x.value;
                console.log(`${file.name}`);
                console.log(file);
                const sumName = `${x.fileFlag}@${file.name}`;
                formData.append('attachFile[]', x.value, sumName);
            }
        })
        const url = 'survey';
        const option = {
            url: url,
            method: HttpMethod.POST,
            body: formData,
            isMultipart: true,
        }
        const act = await httpClient(option);
        // const act: ActionResult = { result: true};
        setSubmitting(false);

        if (act.result) {
            console.log('result');
            const resetData = {
                custNo: custNo!,
                name: '',
                mobile: '',
                couponId: couponId,
                code: surveyCode,
                isGiveAway: true,
            }
            const resetFiles = [{ id: 0, fileFlag: '', value: '' }, { id: 1, fileFlag: '', value: '' }];
            const resetFileNames = [{ id: 0, value: '파일을 선택 해 주세요.' }, { id: 1, value: '파일을 선택 해 주세요.' }];
            setModel(resetData);
            setFiles(resetFiles);
            setFileNames(resetFileNames);
            setSurveyOptions([]);
            setAddress('');
            form.reset();

            props.history.push({
                pathname: '/survey/hogukResult',
                state: { result: true },
            })
        } else {
            alert(`오류:${act.errorMsg}`);
        }

    }

    if (custNo === null || custNo === '' || custNo === undefined) {
        alert('최신버전으로 앱 업데이트 후 이 설문 쿠폰을 작성할 수 있습니다.\n업데이트 후 다시 진행하여 주세요.');
        return <AppUpdatePage/>;
    }

    return (
        <div className={'survey_ho'}>
            <div className={'container survey_container'}>
                <Form noValidate validated={validated} onSubmit={submitForm}>
                    <section>
                        <div>
                            <img src='/img/survey/visual_banner.jpg' className='rounded img-fluid' alt='' />
                        </div>
                    </section>

                    <section>
                        <h5>스탬프투어 참여자</h5>
                            <div className={'mb-3 row desc-wrap'}>
                                <Form.Label column sm={12}>안내사항</Form.Label>
                                <ul>
                                    <li>완주 경품 지급 및 자원봉사 인증서 발급을 위해 완주 설문을 작성해 주셔야 합니다.</li>
                                    <li>경품 지급은 개인정보 수집, 이용 및 제공에 동의한 고객을 대상으로 합니다.</li>
                                    <li>완주 경품은 익월 일괄 발송될 예정이며, 발송 일정은 당사의 사정으로 변경될 수 있습니다. (예: 6월에 투어 완주 시 7월 배송)</li>
                                    <li>완주 경품, SNS 이벤트 경품, 자원 봉사 시간 발급은 모두 참여 가능하며, 참여 횟수는 1회로 제한됩니다.</li>
                                    <li>SNS이벤트는 호국 보훈 스탬프투어가 끝나는 9월 초 게시글이 우수한 30명을 선발하여 기념품을 발송 합니다.</li>
                                    <li>경품 소진 시 지급 이벤트는 조기 마감될 수 있습니다.</li>
                                </ul>
                                <Form.Label column sm={12}>유의사항</Form.Label>
                                <ul>
                                    <li>설문에 작성된 고객 정보로 경품을 발송해 드리며, 정보 미등록 및 오류로 인해 미 배송될 경우 재발송이 불가합니다.</li>
                                    <li>SNS이벤트 및 자원봉사 인증서 발급을 희망하는 분은 반드시 이미지를 첨부해주셔야 합니다.</li>
                                </ul>
                                <Form.Label column sm={12}>이벤트 관련 문의</Form.Label>
                                <ul>
                                    <li>문의처: 제이스탬프 064-747-8900</li>
                                    <li>문의 가능시간: 평일 오전 9시~ 오후 6시(주말, 공휴일 제외)</li>
                                </ul>
                            </div>
                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={2}>회원번호</Form.Label>
                            <Col sm={10}>
                                <Form.Control type={'text'} value={custNo} aria-label='회원번호 자동입력란' disabled readOnly />
                            </Col>
                        </Form.Group>
                    </section>

                    <section>
                        <h5>배송처</h5>
                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={2}>이름</Form.Label>
                            <Col sm={10}>
                                <Form.Control type={'text'} name={'name'} required onChange={handleInputChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={2}>생년월일(6자리)</Form.Label>
                            <Col sm={10}>
                                <Form.Control type={'text'} name={'dev1'} required onChange={handleInputChange}
                                              maxLength={6} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={2}>학교/학년/반(선택항목)</Form.Label>
                            <Col sm={10}>
                                <Form.Control type={'text'} name={'dev2'} onChange={handleInputChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={2}>배송지 주소</Form.Label>
                            <Col sm={10} className={'multi-input'}>
                                <FormControl type={'text'} required placeholder={'기본주소'} name={'addr1'}
                                             onFocus={handlePostOpen} onClick={handlePostOpen} value={address}
                                             onChange={handleInputChange} />
                                <Form.Control type={'text'} required placeholder={'상세주소'} name={'addr2'}
                                              onChange={handleInputChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={2}>연락처</Form.Label>
                            <Col sm={10}>
                                <Form.Control type={'tel'} name={'mobile'} required onChange={handleInputChange}
                                              maxLength={13} />
                            </Col>
                        </Form.Group>
                    </section>

                    <section>
                        <h5>이벤트 참여</h5>
                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={2}>SNS인증(선택항목)</Form.Label>
                            <Col sm={10}>
                                <Form.File
                                    type="file"
                                    id='basic-addon1'
                                    label={fileNames.filter(x => x.id === 0)[0].value}
                                    data-browse='파일선택'
                                    custom
                                    onChange={(e: any) => handleFile(0, 'sns', e)}
                                    name={'file'}
                                />
                                <span className={"discript"}>* SNS에 올린 내용 및 이미지를 화면 캡쳐 후 등록 해 주세요.</span>
                            </Col>
                        </Form.Group>
                        <div>
                            <Form.Group as={Row} className={"mb-3"}>
                                <Form.Label column sm={2} >정화활동 인증(선택항목)</Form.Label>
                                <Col sm={10}>
                                    <Form.File
                                        type="file"
                                        id="basic-addon2"
                                        label={fileNames.filter(x => x.id === 1)[0].value}
                                        data-browse="파일선택"
                                        custom
                                        onChange={(e:any) => handleFile(1, 'clean', e)}
                                    />
                                    <span className={"discript"}>* 정화활동 사진을 등록 해 주세요.</span>
                                    <br/>
                                    <span className={"discript"}>* 봉사시간 제공 대상은 '학생'이므로, 반드시 "학교,학년,반" 입력 후 파일을 첨부 해 주세요.</span>
                                </Col>
                            </Form.Group>
                            {/*<p className={'file-desc-txt'}>*/}
                            {/*    * 자원봉사 인증서 발급은 학생 대상 이벤트입니다.<br/>*/}
                            {/*    &nbsp;&nbsp;‘학교/학년/반’을 필수로 입력해야 인증서 발급이 가능합니다*/}
                            {/*</p>*/}
                        </div>
                    </section>

                    <section>
                        <h5>고객 만족도 설문조사</h5>

                        <Form.Group as={Row} className={'mb-3'} controlId={'SurveyOption'}>
                            <Form.Label column sm={12}>거주지역은 어디인가요?</Form.Label>
                            <Col sm={12}>
                                <Form.Control as='select' required name={'option1'}
                                              onChange={(e) => handelChildDepthChagen(1, e)}>
                                    <option value={''}>선택해주세요</option>
                                    {
                                        option1list.map((item, index) => (
                                            <option value={item} key={index}>{item}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={12}>성별은 어떻게 되세요?</Form.Label>
                            <Col sm={12}>
                                <Form.Control as='select' required name={'option2'}
                                              onChange={(e) => handelChildDepthChagen(1, e)}>
                                    <option value={''}>선택해주세요</option>
                                    {
                                        option2list.map((item, index) => (
                                            <option value={item} key={index}>{item}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={12}>호국보훈 스탬프투어는 만족스러우셨나요?</Form.Label>
                            <Col sm={12}>
                                <Form.Control as='select' required name={'option3'}
                                              onChange={(e) => handelChildDepthChagen(1, e)}>
                                    <option value={''}>선택해주세요</option>
                                    {
                                        option3list.map((item, index) => (
                                            <option value={item} key={index}>{item}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className={'mb-3'}>
                            <Form.Label column sm={12}>가장 인상 깊었던 장소는 어디인가요?</Form.Label>
                            <Col sm={12}>
                                <Form.Control as='select' required name={'option4'}
                                              onChange={(e) => handelChildDepthChagen(1, e)}>
                                    <option value={''}>선택해주세요</option>
                                    {
                                        option4list.map((item, index) => (
                                            <option value={item} key={index}>{item}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Col>
                        </Form.Group>
                    </section>

                    <section>
                        <h5>개인정보 수집,이용</h5>
                        <div className={'mb-3 row'}>
                            <div className={'info'}>
                                귀사가 본인의 개인(신용)정보를 수집, 이용하고자 하는 경우에는 『개인정보보호법』 제 15조 및 제 22조에 따라 동의를 얻어야 합니다. 이에 본인은 귀사가 아래의 내용과 같이 본인의 개인(신용)정보를 수집. 이용하는데 동의합니다.
                                <br />- 개인정보의 수집•이용 목적 : 당사의 경품 이벤트 당첨자 대상 경품 배송 및 자원봉사 인증서 발급
                                <br />- 수집•이용할 개인정보의 내용 : 개인식별정보 : 성명, 연락처(핸드폰), 주소, 생년월일, 학교/학년/반
                                <br />개인정보의 보유•이용 기간 : 경품 당첨자에 한하여 수집•이용 동의일로부터 12개월까지
                            </div>
                        </div>
                    </section>

                    <section>
                        <h5>개인정보 제공</h5>
                        <div className={'mb-3 row'}>
                            <div className={'info'}>
                                귀사가 본인의 개인정보를 제3자에게 제공하고자 하는 경우에는 『개인정보보호법』 제 15조 및 제 22조에 따라 동의를 얻어야 합니다. 이에 본인은 귀사가 아래의 내용과 같이 본인의 개인정보를 제공하는데 동의합니다.
                                <p>
                                    □ 개인정보를 제공받는 자
                                    <br />필요한 업무를 위탁받은자 : 제주보훈청, 투어 운영업체 주)박스트리<br />
                                    □ 개인정보를 제공받는 자의 이용 목적
                                    <br />필요한 업무를 위탁받은자 : 이벤트 진행 및 경품배송<br />
                                    □ 제공할 개인정보의 내용
                                    <br />개인식별정보 : 성명, 연락처(핸드폰), 주소, 생년월일<br />
                                    □ 제공 받는 자의 개인정보 보유•이용 기간
                                    <br />필요한 업무를 위탁받은자 : 수집•이용 동의일로부터 12개월까지<br />
                                    □ 동의를 거부할 권리 및 거부할 경우 불이익
                                    <br />귀하는 상기 동의를 거부할 수 있습니다. 다만, 이에 대한 동의를 하지 않는 경우에는 경품 지급이 불가능함을 알려드립니다.
                                </p>
                            </div>
                        </div>
                    </section>

                    <section>
                        <h5>상기 개인정보 수집, 이용 및 제공에 동의합니다</h5>
                        <div className={'mb-3 row'}>
                            <div className={'info'}>
                                <Form.Check type={'radio'} label={'네'} name='isGiveAway' value={'true'}
                                            defaultChecked={true} onChange={handleRadioChange} />
                                <Form.Check type={'radio'} label={'아니오(설문참여만 하실 뿐 경품은 지급되지 않습니다.)'} name='isGiveAway'
                                            value={'false'} onChange={handleRadioChange} />
                            </div>
                        </div>
                    </section>

                    <section>
                        <div className={'mb-3 row'}>
                            <div className={'info button-wrap'}>
                                {/*<button type="button" className="btn btn-primary" onClick="location.href='ho_end.html' ">제출하기</button>*/}
                                <button type='submit' className='btn btn-primary' disabled={submitting}>{
                                    submitting ? '전송중...' : '제출하기'
                                }</button>
                                <button type='reset' className='btn btn-outline-secondary' onClick={resetForm}>양식 지우기
                                </button>
                            </div>
                        </div>
                    </section>

                </Form>
            </div>
            {
                openPost &&
                <div className={'fix-Post'} onClick={handlePostClose}>
                    <div className={'post-wrap'}>
                        <div className={'closeBtn-wrap'}>
                            <Button className={'closeBtn'} onClick={handlePostClose}>창닫기</Button>
                        </div>
                        <DaumPostCode
                            onComplete={handleComplete}
                            className={'post-div'}
                        />
                        {/*<PostCode/>*/}
                    </div>
                </div>
            }
        </div>
    )
}

export default Ho
